var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9.24414V11.4941H9.75V9.24414H15V14.4941C15 14.9084 14.6642 15.2441 14.25 15.2441H0.75C0.33579 15.2441 0 14.9084 0 14.4941V9.24414H5.25ZM6.75 7.74414H8.25V9.99414H6.75V7.74414ZM3.75 3.24414V0.994141C3.75 0.579931 4.08579 0.244141 4.5 0.244141H10.5C10.9142 0.244141 11.25 0.579931 11.25 0.994141V3.24414H14.25C14.6642 3.24414 15 3.57993 15 3.99414V7.74414H9.75V6.24414H5.25V7.74414H0V3.99414C0 3.57993 0.33579 3.24414 0.75 3.24414H3.75ZM5.25 1.74414V3.24414H9.75V1.74414H5.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.71677446a056224def97118d84ef38d1.svg";
export { ForwardRef as ReactComponent };